import { render, staticRenderFns } from "./QualityService.vue?vue&type=template&id=65bf2d34&scoped=true"
import script from "./QualityService.vue?vue&type=script&lang=js"
export * from "./QualityService.vue?vue&type=script&lang=js"
import style0 from "./QualityService.vue?vue&type=style&index=0&id=65bf2d34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_dshyztwqotzq6hkhxg56wcmkza/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bf2d34",
  null
  
)

export default component.exports